import homeImg from "../../assets/img/home.png";

export default function HomeSection() {
  return (
    <section className="home section" id="home">
      <div className="home__container container grid">
        <div className="home__data">
          <div className="home__header">
            <h1 className="home__title">Topgun</h1>
            <h2 className="home__subtitle">Aviation</h2>
          </div>

          <div className="home__footer">
            <h3 className="home__title-description">Overview</h3>
            <p className="home__description">
              The definitive app for aviation enthusiasts, students, and military
              professionals. Dive into an unmatched collection of over 2,000
              aircraft, including fighter jets, bombers, helicopters, and attack
              aircraft — all packed with rich details, stunning photos, videos,
              3D models, and interactive AR experiences.
            </p>

            <a href="#download" className="button button--flex">
              <span className="button--flex">
                <i className="ri-download-2-line button__icon" /> Download Now
              </span>
            </a>
          </div>
        </div>

        <div className="home__screenshot_container">
          <img
            src={homeImg}
            alt="Topgun App Screenshot"
            className="home__screenshot"
          />
        </div>
      </div>
    </section>
  );
}
